import { create } from 'zustand'
import { supabase } from '../lib/supabase'

export const useAuthStore = create((set) => ({
  user: null,
  loading: true,

  initialize: async () => {
    if (!supabase) {
      set({ loading: false })
      return
    }

    // Pick up session tokens passed from Hub via query params
    const params = new URLSearchParams(window.location.search)
    const hubToken = params.get('hub_token')
    const hubRefresh = params.get('hub_refresh')
    if (hubToken && hubRefresh) {
      // Strip only the tokens: other params (like ?checkin= from a slip QR
      // code) have to survive the Hub sign-in round trip.
      params.delete('hub_token')
      params.delete('hub_refresh')
      const rest = params.toString()
      const cleanUrl = window.location.origin + window.location.pathname + (rest ? `?${rest}` : '')
      window.history.replaceState({}, '', cleanUrl)
      await supabase.auth.setSession({ access_token: hubToken, refresh_token: hubRefresh })
    }

    const { data: { session } } = await supabase.auth.getSession()
    set({ user: session?.user || null, loading: false })

    supabase.auth.onAuthStateChange((_event, session) => {
      set({ user: session?.user || null })
    })
  },

  signOut: async () => {
    if (supabase) await supabase.auth.signOut()
    set({ user: null })
  },
}))
